// import Printable from "components/modules/reporting/A4";
// import React, { useRef, useState } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import logo from "../../../../assets/img/logos/logoNew.png";

// export default function BalanceSheetReport() {
//   const navigate = useNavigate();
//   const { state: locationState } = useLocation();
//   const printRef = useRef();
//   const [asOfDate, setAsOfDate] = useState(
//     () => new Date().toISOString().split("T")[0]
//   );

//   // Mock data
//   const state = locationState || {
//     currentAssets: [
//       { id: 1, name: "Cash", amount: 5000 },
//       { id: 2, name: "Accounts Receivable", amount: 12000 },
//     ],
//     totalCurrentAssets: 17000,
//     fixedAssets: [
//       { id: 3, name: "Equipment", amount: 15000 },
//       { id: 4, name: "Buildings", amount: 25000 },
//     ],
//     totalFixedAssets: 40000,
//     totalAssets: 57000,
//     currentLiabilities: [{ id: 5, name: "Accounts Payable", amount: 8000 }],
//     totalCurrentLiabilities: 8000,
//     longTermLiabilities: [{ id: 6, name: "Bank Loan", amount: 10000 }],
//     totalLongTermLiabilities: 10000,
//     equityAccounts: [{ id: 7, name: "Capital", amount: 30000 }],
//     retainedEarnings: 9000,
//     totalEquity: 39000,
//     totalLiabilitiesEquity: 57000,
//   };

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   return (
//     <Card>
//       <Card.Header className="border-bottom bg-light">
//         <Row className="flex-between-center">
//           <Col md>
//             <div className="d-flex align-items-center">
//               <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                 Reports | Balance Sheet
//               </h5>
//               <div className="d-flex align-items-center gap-2 mx-4">
//                 <span style={{ color: "black" }}>From Date:</span>
//                 <Form.Group className="" controlId="formGroupFromDate">
//                   <Form.Control type="date" />
//                 </Form.Group>
//                 <span style={{ color: "black" }}>To Date:</span>
//                 <Form.Group className="" controlId="formGroupToDate">
//                   <Form.Control type="date" />
//                 </Form.Group>
//               </div>
//             </div>
//           </Col>
//           <Col xs="auto">
//             <Button
//               variant="link"
//               className="text-secondary fw-medium p-0 me-3"
//               type="button"
//               onClick={() => navigate(-1)}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={triggerPrint}>
//               Print
//             </Button>
//           </Col>
//         </Row>
//       </Card.Header>

//       <Printable ref={printRef} documentTitle="Balance Sheet Report">
//         <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
//           {/* Header */}
//           <div className="d-flex justify-content-between">
//             <div>
//               <div style={{ textAlign: "center", color: "black" }}>
//                 <img
//                   height={80}
//                   width={80}
//                   src={logo}
//                   alt="Logo"
//                   style={{ marginBottom: "20px" }}
//                 />
//               </div>
//               <h4 style={{ textAlign: "center", color: "black" }}>
//                 Balance Sheet
//               </h4>
//             </div>
//             <div></div>
//           </div>

//           {/* Reference and Company */}
//           <div className="d-flex justify-content-between my-4">
//             <div>
//               <strong>Company Name:</strong> ABC Corporation
//               <br />
//               <strong>Address:</strong> 123 Main St, City, Country
//             </div>
//             <div className="text-end">
//               <div>
//                 <strong>REF. NO.:</strong> 123123124
//               </div>
//               <div>
//                 <strong>Generated:</strong> {new Date().toLocaleDateString()}
//               </div>
//             </div>
//           </div>

//           {/* Utility Table Render Function */}
//           {renderSection("ASSETS", [
//             {
//               title: "Current Assets",
//               items: state.currentAssets,
//               total: state.totalCurrentAssets,
//               totalLabel: "Total Current Assets",
//             },
//             {
//               title: "Fixed Assets",
//               items: state.fixedAssets,
//               total: state.totalFixedAssets,
//               totalLabel: "Total Fixed Assets",
//             },
//             {
//               title: "TOTAL ASSETS",
//               isTotal: true,
//               total: state.totalAssets,
//             },
//           ])}

//           {renderSection("LIABILITIES & EQUITY", [
//             {
//               title: "Current Liabilities",
//               items: state.currentLiabilities,
//               total: state.totalCurrentLiabilities,
//               totalLabel: "Total Current Liabilities",
//             },
//             {
//               title: "Long-term Liabilities",
//               items: state.longTermLiabilities,
//               total: state.totalLongTermLiabilities,
//               totalLabel: "Total Long-term Liabilities",
//             },
//             {
//               title: "Equity",
//               items: state.equityAccounts.concat([
//                 {
//                   id: 999,
//                   name: "Retained Earnings",
//                   amount: state.retainedEarnings,
//                 },
//               ]),
//               total: state.totalEquity,
//               totalLabel: "Total Equity",
//             },
//             {
//               title: "TOTAL LIABILITIES & EQUITY",
//               isTotal: true,
//               total: state.totalLiabilitiesEquity,
//             },
//           ])}

//           {/* Approval */}
//           <div className="d-flex justify-content-between mt-5">
//             <div>APPROVED BY:</div>
//             <div
//               style={{ borderBottom: "1px solid #000", width: "250px" }}
//             ></div>
//           </div>
//         </div>
//       </Printable>
//     </Card>
//   );
// }

// function renderSection(header, groups) {
//   return (
//     <div style={{ marginTop: 30 }}>
//       <h5
//         style={{
//           border: "1px solid #000",
//           padding: 8,
//           backgroundColor: "#e6e6e6",
//           color: "#000",
//         }}
//       >
//         {header}
//       </h5>
//       {groups.map((group, idx) => (
//         <div key={idx} style={{ marginTop: 15 }}>
//           {!group.isTotal && (
//             <h6 style={{ fontWeight: "bold", marginLeft: 10 }}>
//               {group.title}
//             </h6>
//           )}
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               marginLeft: 10,
//               marginTop: 5,
//             }}
//           >
//             <tbody>
//               {group.items?.map((item) => (
//                 <tr key={item.id}>
//                   <td style={{ ...styles.td, paddingLeft: 30 }}>{item.name}</td>
//                   <td style={styles.tdP}>{item.amount.toLocaleString()}</td>
//                 </tr>
//               ))}
//               {!group.isTotal && (
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 30 }}>
//                     {group.totalLabel}
//                   </td>
//                   <td style={styles.tdF}>{group.total?.toLocaleString()}</td>
//                 </tr>
//               )}
//               {group.isTotal && (
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     {group.title}
//                   </td>
//                   <td style={styles.tdF}>{group.total?.toLocaleString()}</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       ))}
//     </div>
//   );
// }

// const styles = {
//   td: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#fff",
//   },
//   tdP: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//     backgroundColor: "#fff",
//   },
//   tdFT: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//   },
//   tdF: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//     backgroundColor: "#e6e6e6",
//   },
// };

import Printable from "components/modules/reporting/A4";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/img/logos/logoNew.png";
import { useFetchFinanceBook } from "hooks/useFetchFinanceBook";
import { useSettingContext } from "context/SettingContext";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

export default function BalanceSheetReport() {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const printRef = useRef();
  const headerRef = useRef();
  const collapseButtonRef = useRef();
  const [reportData, setReportData] = useState(null);

  const [asOfDate, setAsOfDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );

  // Mock data
  const state = locationState || {
    currentAssets: [
      { id: 1, name: "Cash", amount: 5000 },
      { id: 2, name: "Accounts Receivable", amount: 12000 },
    ],
    totalCurrentAssets: 17000,
    fixedAssets: [
      { id: 3, name: "Equipment", amount: 15000 },
      { id: 4, name: "Buildings", amount: 25000 },
    ],
    totalFixedAssets: 40000,
    totalAssets: 57000,
    currentLiabilities: [{ id: 5, name: "Accounts Payable", amount: 8000 }],
    totalCurrentLiabilities: 8000,
    longTermLiabilities: [{ id: 6, name: "Bank Loan", amount: 10000 }],
    totalLongTermLiabilities: 10000,
    equityAccounts: [{ id: 7, name: "Capital", amount: 30000 }],
    retainedEarnings: 9000,
    totalEquity: 39000,
    totalLiabilitiesEquity: 57000,
  };

  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  const settingsData = useSettingContext();
  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );
  const costCenterId = Number(costCenter?.value) || 1; // Ensure it's a number

  const { data: financeBooksData, isLoading: financeBookLoading } =
    useFetchFinanceBook(costCenterId);

  const [collapseIn, setCollapseIn] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const toggleFilters = () => setCollapseIn(!collapseIn);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setIsHeaderVisible(rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <PageTitle name="Reports | Balance Sheet" />

      <Card>
        {/* <Card.Header className="border-bottom bg-light">
        <Row className="flex-between-center">
          <Col md>
            <div className="d-flex align-items-center">
              <h5
                className="fs-9 text-nowrap mb-2 mb-md-0"
                style={{ width: "19.5rem" }}
              >
                Reports | Balance Sheet
              </h5>

              <div className="d-flex align-items-center gap-2">
                <Form.Select
                  aria-label="Fiscal Year"
                  className="fs-9"
                  style={{ width: "200px" }}
                >
                  <option value="">Finance Book</option>
                  {financeBooksData?.data.data.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>

                <Form.Select aria-label="Fiscal Year" className="">
                  <option value="">Fiscal Year</option>
                  <option value="2023">2023-2024</option>
                  <option value="2024">2024-2025</option>
                </Form.Select>
              </div>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={triggerPrint}>
              Print
            </Button>
          </Col>
        </Row>
      </Card.Header> */}
        <Card.Header
          ref={headerRef}
          className="border-bottom sticky-header"
          style={{
            position: "sticky",
            top: -90,
            backgroundColor: "white",
            zIndex: 1000,
            paddingBottom: collapseIn ? "1rem" : "1.5rem",
            transition: "padding-bottom 0.3s ease",
          }}
        >
          <div className="header-content">
            <Row className="flex-between-center align-items-center">
              <Col md>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  {/* <h5
                    className="fs-9 text-nowrap mb-2 mb-md-0"
                    style={{ width: "19.5rem" }}
                  >
                    Reports | Balance Sheet
                  </h5> */}
                  <div style={{ width: "19.5rem" }}>
                    <BreadCrumbTable title="Reports" subTitle="Balance Sheet" />
                  </div>
                </div>
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-secondary fw-medium p-0 me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                {reportData ? (
                  <>
                    <Button variant="primary" onClick={triggerPrint}>
                      Print
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="primary">Preview</Button>
                  </>
                )}
              </Col>
            </Row>

            <Collapse in={collapseIn}>
              <div className="filter-row">
                <Row className="mt-3">
                  <Col
                    md="auto"
                    style={{
                      marginLeft: "20rem",
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <Form.Select
                      aria-label="Fiscal Year"
                      className="fs-9"
                      style={{ width: "180px" }}
                    >
                      <option value="">Finance Book</option>
                      {financeBooksData?.data.data.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Select aria-label="Fiscal Year" className="">
                      <option value="">Fiscal Year</option>
                      <option value="2023">2023-2024</option>
                      <option value="2024">2024-2025</option>
                    </Form.Select>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* Collapse toggle button fixed to border-bottom */}
          <div
            ref={collapseButtonRef}
            style={{
              position: "absolute",
              right: "7.5rem",
              bottom: "-15px",
              zIndex: 1001,
              backgroundColor: "white",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px white",
              visibility: isHeaderVisible ? "visible" : "hidden",
              transition: "visibility 0.2s ease",
            }}
          >
            {collapseIn ? (
              <IoIosArrowDropup
                title="Hide Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            ) : (
              <IoIosArrowDropdown
                title="Show Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            )}
          </div>
        </Card.Header>

        <Printable ref={printRef} documentTitle="Balance Sheet Report">
          {reportData && (
            <div style={{ padding: 40, fontSize: "14px" }}>
              {/* Header */}
              <div className="d-flex justify-content-between">
                <div>
                  <div style={{ textAlign: "center", color: "black" }}>
                    <img
                      height={80}
                      width={80}
                      src={logo}
                      alt="Logo"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                  <h4 style={{ textAlign: "center", color: "black" }}>
                    Balance Sheet
                  </h4>
                </div>
                <div></div>
              </div>

              {/* Reference and Company */}
              <div className="d-flex justify-content-between my-4">
                <div>
                  <strong>Company Name:</strong> ABC Corporation
                  <br />
                  <strong>Address:</strong> 123 Main St, City, Country
                </div>
                <div className="text-end">
                  <div>
                    <strong>Fiscal Year:</strong> 2024-2025
                  </div>
                  <div>
                    <strong>Printed:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* === ASSETS SECTION === */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th colSpan={2} style={styles.toPth}>
                        ASSETS
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Current Assets</span>
                      </td>
                    </tr>
                    {state.currentAssets.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Current Assets
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalCurrentAssets)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Fixed Assets</span>
                      </td>
                    </tr>
                    {state.fixedAssets.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Fixed Assets
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalFixedAssets)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...styles.tdTotal, paddingLeft: "10px" }}>
                        <strong>TOTAL ASSETS</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(state.totalAssets)}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* === LIABILITIES & EQUITY SECTION === */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th colSpan={2} style={styles.toPth}>
                        LIABILITIES & EQUITY
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>
                          Current Liabilities
                        </span>
                      </td>
                    </tr>
                    {state.currentLiabilities.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Current Liabilities
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalCurrentLiabilities)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>
                          Long-term Liabilities
                        </span>
                      </td>
                    </tr>
                    {state.longTermLiabilities.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Long-term Liabilities
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLongTermLiabilities)}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>Equity</span>
                      </td>
                    </tr>
                    {state.equityAccounts.map((item) => (
                      <tr key={item.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {item.name}
                        </td>
                        <td style={styles.tdP}>{formatAmount(item.amount)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.td, paddingLeft: "30px" }}>
                        Retained Earnings
                      </td>
                      <td style={styles.tdP}>
                        {formatAmount(state.retainedEarnings)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Equity
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquity)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...styles.tdTotal, paddingLeft: "10px" }}>
                        <strong>TOTAL LIABILITIES & EQUITY</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>
                          {formatAmount(state.totalLiabilitiesEquity)}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Approval Signature */}
              <div
                style={{
                  marginTop: 100,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: 300, textAlign: "center" }}>
                  <div
                    style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                  ></div>
                  <div>Authorized Signature</div>
                </div>
              </div>
            </div>
          )}
        </Printable>
      </Card>
    </>
  );
}

const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  lightGray: "#f8f8f8",
  gray: "#e6e6e6",
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  toPth: {
    backgroundColor: bg.darkGray,
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
  },
  td: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdGroup: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.gray,
    fontWeight: "bold",
  },
  tdSubtotal: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdSubtotalP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdTotal: {
    border,
    borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
};
